import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, isRef as _isRef, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11ca9a4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-tree-node" }
const _hoisted_2 = { class: "mr10" }
const _hoisted_3 = { class: "position" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "削除しますか？", -1))
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("削除")

import { ref, computed } from "vue"
import { useStore } from "vuex";

import CategoryAddDialog from "@/components/common/categories/CategoryAddDialog.vue";
import CategoryEditDialog from "@/components/common/categories/CategoryEditDialog.vue";
import { Category } from "@/types/category";
import {  Plus, Edit, Delete } from '@element-plus/icons';


interface Props {
  categories: Category[];
}
interface Emits {
  (e: 'updateCategory', _targetId: number, name: string): void;
  (e: 'addCategory', _parentId: number, name: string): void;
  (e: 'deleteCategory', _id: number): void;
  (e: 'sortCategory', _targetId: number, _dependId: number, _type: string): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    categories: { type: Array, required: true }
  },
  emits: ["updateCategory", "addCategory", "deleteCategory", "sortCategory"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateCategory', _targetId: number, name: string): void;
  (e: 'addCategory', _parentId: number, name: string): void;
  (e: 'deleteCategory', _id: number): void;
  (e: 'sortCategory', _targetId: number, _dependId: number, _type: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  categories: Category[];
}




const store = useStore();
let formCategoryVisible = ref(false);
let formEditCategoryVisible = ref(false);
let formRemoveCategoryVisible = ref(false);
let editingCategoryName = ref("");
let formCategoryId = ref(0);
let categorydefaultProps = {
  children: "children",
  label: "name",
};
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);

const handleNodeClick = (data) => {
  formCategoryId.value = data.id
};
const updateCategoryAndClose = (targetId, name) => {
  emit("updateCategory", targetId, name);
  formEditCategoryVisible.value = false;
};
const addCategory = (parentId, name) => {
  emit("addCategory", parentId, name);
};
const deleteCategory = () => {
  emit("deleteCategory", formCategoryId.value);
};
// eslint-disable-next-line
const allowDrop = (_draggingNode, dropNode, type) => {
  if (dropNode.data.id == 0) {
    return false;
  }
  return true;
};
const allowDrag = (draggingNode) => {
  if (draggingNode.data.id == 0) {
    return false;
  }
  return true;
  // return draggingNode.data.label.indexOf('Level three 3-1-1') === -1
};
// eslint-disable-next-line
const handleDrop = (draggingNode, dropNode, dropType, ev) => {
  emit(
    "sortCategory",
    draggingNode.data.id,
    dropNode.data.id,
    dropType
  );
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tree, {
      data: __props.categories,
      props: _unref(categorydefaultProps),
      onNodeClick: handleNodeClick,
      "node-key": "id",
      "expand-on-click-node": false,
      "default-expand-all": "",
      "highlight-current": "",
      draggable: "",
      "allow-drop": allowDrop,
      "allow-drag": allowDrag,
      onNodeDrop: handleDrop
    }, {
      default: _withCtx(({ node, data }) => [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(node.label), 1),
          _createElementVNode("span", _hoisted_3, [
            (_unref(managerFlg))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  icon: _unref(Plus),
                  class: "button-minimini",
                  circle: "",
                  type: "primary",
                  onClick: _withModifiers(($event: any) => {_isRef(formCategoryId) //@ts-ignore
 ? formCategoryId.value = data.id : formCategoryId = data.id; _isRef(formCategoryVisible) //@ts-ignore
 ? formCategoryVisible.value = !_unref(formCategoryVisible) : formCategoryVisible = !_unref(formCategoryVisible);}, ["stop"])
                }, null, 8, ["icon", "onClick"])), [
                  [_vShow, _unref(formCategoryId) == data.id]
                ])
              : _createCommentVNode("", true),
            (_unref(managerFlg))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  icon: _unref(Edit),
                  class: "button-minimini",
                  circle: "",
                  type: "primary",
                  onClick: _withModifiers(($event: any) => {_isRef(formCategoryId) //@ts-ignore
 ? formCategoryId.value = data.id : formCategoryId = data.id; _isRef(editingCategoryName) //@ts-ignore
 ? editingCategoryName.value = data.name : editingCategoryName = data.name; _isRef(formEditCategoryVisible) //@ts-ignore
 ? formEditCategoryVisible.value = !_unref(formEditCategoryVisible) : formEditCategoryVisible = !_unref(formEditCategoryVisible);}, ["stop"])
                }, null, 8, ["icon", "onClick"])), [
                  [_vShow, _unref(formCategoryId) == data.id && data.id != 0]
                ])
              : _createCommentVNode("", true),
            (_unref(managerFlg))
              ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  icon: _unref(Delete),
                  class: "button-minimini",
                  circle: "",
                  type: "primary",
                  onClick: _withModifiers(($event: any) => {_isRef(formCategoryId) //@ts-ignore
 ? formCategoryId.value = data.id : formCategoryId = data.id; _isRef(formRemoveCategoryVisible) //@ts-ignore
 ? formRemoveCategoryVisible.value = !_unref(formRemoveCategoryVisible) : formRemoveCategoryVisible = !_unref(formRemoveCategoryVisible);}, ["stop"])
                }, null, 8, ["icon", "onClick"])), [
                  [_vShow, 
                _unref(formCategoryId) == data.id &&
                data.id != 0 &&
                data.content_count == 0 &&
                data.children &&
                data.children.length == 0
              ]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["data", "props"]),
    _createVNode(CategoryAddDialog, {
      modelValue: _unref(formCategoryVisible),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(formCategoryVisible) ? (formCategoryVisible).value = $event : formCategoryVisible = $event)),
      parentId: _unref(formCategoryId),
      onAddCategory: addCategory
    }, null, 8, ["modelValue", "parentId"]),
    _createVNode(CategoryEditDialog, {
      modelValue: _unref(formEditCategoryVisible),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(formEditCategoryVisible) ? (formEditCategoryVisible).value = $event : formEditCategoryVisible = $event)),
      targetId: _unref(formCategoryId),
      targetName: _unref(editingCategoryName),
      onUpdateCategory: updateCategoryAndClose
    }, null, 8, ["modelValue", "targetId", "targetName"]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(formRemoveCategoryVisible),
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(formRemoveCategoryVisible) ? (formRemoveCategoryVisible).value = $event : formRemoveCategoryVisible = $event)),
      title: "削除確認",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_5, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(formRemoveCategoryVisible) //@ts-ignore
 ? formRemoveCategoryVisible.value = false : formRemoveCategoryVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => {_isRef(formRemoveCategoryVisible) //@ts-ignore
 ? formRemoveCategoryVisible.value = false : formRemoveCategoryVisible = false; deleteCategory();})
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})